import { render, staticRenderFns } from "./serves.vue?vue&type=template&id=18abdd3e&scoped=true&"
import script from "./serves.vue?vue&type=script&lang=js&"
export * from "./serves.vue?vue&type=script&lang=js&"
import style0 from "./serves.vue?vue&type=style&index=0&id=18abdd3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18abdd3e",
  null
  
)

export default component.exports